module.exports = __webpack_public_path__ + "static/howtomaintainprivacy-410515c83c2de2197d86f541aa1b2b7e.gif";